import {
    Dialog, DialogTitle, DialogContent, DialogActions, Typography,
    TextField, Button, Snackbar, Alert, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, IconButton
} from '@mui/material';
import { useEffect, useState, useCallback } from 'react';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import axios from 'axios';
import urls from '../../Mobx/Urls';

const UpdateUserGoal = ({ user, isOpen, onClose }) => {
    const [goalId, setGoalId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
    const [availableGoals, setAvailableGoals] = useState([]);

    // Fetch available goals from the server
    const fetchGoals = useCallback(async () => {
        try {
            if (!user) return;
            const response = await axios.get(urls.admin.getAllGoalsForUser + user?.id, {
                withCredentials: true
            });
            setAvailableGoals(response.data.joinedGoals);
        } catch (error) {
            setErrorMessage('Failed to fetch available goals. error: ' + error.message);
            setIsSnackbarOpen(true);
        }
    }, [user]);

    useEffect(() => {
        fetchGoals();
    }, [user, fetchGoals]);

    const handleSubmit = async () => {
        setIsSubmitting(true);
        setErrorMessage('');
        try {
            await axios.post(urls.admin.addUserToGoal, {
                userId: user.id,
                goalId
            }, { withCredentials: true });
            fetchGoals();
        } catch (error) {
            setErrorMessage('Failed to update user goal. error: ' + error.message);
            setIsSnackbarOpen(true);
        } finally {
            setIsSubmitting(false);
        }
    };

    const onRemove = async (goal) => {
        setIsSubmitting(true);
        setErrorMessage('');
        try {
            await axios.post(urls.admin.removeUserFromGoal, {
                userId: user.id,
                goalId: goal._id
            }, { withCredentials: true });
            fetchGoals();
        } catch (error) {
            setErrorMessage('Failed to remove user from goal. error: ' + error.message);
            setIsSnackbarOpen(true);
        } finally {
            setIsSubmitting(false);
        }
    };


    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogTitle>כיתות</DialogTitle>
            <DialogContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>id</TableCell>
                                <TableCell>שם</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פעולות</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {availableGoals.map((goal) => (
                                <TableRow key={goal._id}>
                                    <TableCell>{goal._id}</TableCell>
                                    <TableCell>{goal.title}</TableCell>
                                    <TableCell>
                                        <IconButton onClick={() => onRemove(goal)}>
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography>כיתה :</Typography>
                <TextField
                    fullWidth
                    value={goalId}
                    onChange={(e) => setGoalId(e.target.value)}
                    margin="normal"
                >
                </TextField>
                <Button onClick={handleSubmit} disabled={isSubmitting} variant="contained" color="primary">
                    עדכן
                </Button>
                {errorMessage && (
                    <Typography color="error">{errorMessage}</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={isSubmitting} variant="contained" color="primary">סגור</Button>
            </DialogActions>
            <Snackbar
                open={isSnackbarOpen}
                autoHideDuration={6000}
                onClose={() => setIsSnackbarOpen(false)}
            >
                <Alert onClose={() => setIsSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
        </Dialog>
    );
};

export default UpdateUserGoal;